import { Content } from "@prismicio/client";
import { PrismicImage } from "@prismicio/react";
import React from "react";
import style from "./Background.module.scss";

interface Props {
  modalContent?:
    | Content.EmailCapturePopupDocument
    | Content.EmailCapturePopupStagingDocument
    | Content.ReferralPopupDocument
    | Content.ReferralPopupStagingDocument;
}
export default function Background({ modalContent }: Props) {
  return (
    <div className={style.background}>
      <PrismicImage
        field={modalContent?.data.image1}
        className={style.image1}
      />
      <PrismicImage
        field={modalContent?.data.image2}
        className={style.image2}
      />
      <PrismicImage
        field={modalContent?.data.image3}
        className={style.image3}
      />
    </div>
  );
}
